import { render, staticRenderFns } from "./BaseLists.vue?vue&type=template&id=5f3c946c&scoped=true&"
import script from "./BaseLists.vue?vue&type=script&lang=js&"
export * from "./BaseLists.vue?vue&type=script&lang=js&"
import style0 from "./BaseLists.vue?vue&type=style&index=0&id=5f3c946c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3c946c",
  null
  
)

export default component.exports